module.exports = __webpack_public_path__ + "img/photon.4553c1f2.jpg";